<script>
import Topbar from './topbar'
import HorizontalNav from '../shared/horizontal-nav'
import Footer from '../shared/footer'
import { Purchasing, Sales, default as AllItems } from '../menu/admin/index'

import { layoutComputed } from '@/state/helpers'
import { mapState } from 'vuex'

/**
 * Horizontal-layout
 */
export default {
  components: {
    Topbar,
    HorizontalNav,
    Footer
  },
  data () {
    return {}
  },
  computed: {
    ...layoutComputed,
    ...mapState('appModule', ['currentModule']),
    menuItems () {
      return AllItems
      /* switch (this.currentModule) {
        case 'sales':
          return Sales
        case 'purchasing':
          return Purchasing
        default:
          return []
      } */
    }
  },
  created: () => {
    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-topbar', 'dark')
    document.body.removeAttribute('data-sidebar')
    document.body.removeAttribute('data-layout-size')
  },
  methods: {
    toggleRightSidebar () {
      document.body.classList.toggle('right-bar-enabled')
    },
    hideRightSidebar () {
      document.body.classList.remove('right-bar-enabled')
    }
  },
  mounted () {
    if (this.loader === true) {
      document.getElementById('preloader').style.display = 'block'
      document.getElementById('status').style.display = 'block'

      setTimeout(function () {
        document.getElementById('preloader').style.display = 'none'
        document.getElementById('status').style.display = 'none'
      }, 2500)
    } else {
      document.getElementById('preloader').style.display = 'none'
      document.getElementById('status').style.display = 'none'
    }
  }
}
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <Topbar :type="topbar" :width="layoutWidth" />
      <HorizontalNav :items="menuItems" />
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <slot />
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->
        <Footer />
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
  </div>
</template>
